import { createSelector } from 'reselect';
import { getFromState } from 'helpers';

export const getUser = (state) => getFromState(() => state, 'user');

export const getInitialUserValues = createSelector(
  getUser,
  (user) => user,
);
